import React from 'react'
import unipay from '../../assets/logo.svg'
function UniPay() {
	return (
		<div className='uniPayData'>
			<div className='uniPay container'><img src={unipay} alt='imgs' />
				<p>Redefining financial fluidity by bridging fiat and crypto assets in one intelligent ecosystem.</p>
			</div>
		</div>
	)
}

export default UniPay